import React from 'react'
 
export default function NewInfo({st}) {
  return (
    <div>
      {`released on ${st}`}
    </div>
  )
}
